import React from "react"
import { useLocation } from "react-router-dom"

import { useSchedule } from "@shared/contexts"

interface Props {
  src?: string
  link?: string
}

export default function Thumbnail({ src, link }: Props) {
  const { schedule } = useSchedule()
  const { pathname } = useLocation()

  const isVod = pathname.includes("vods")
  const isPaidSchedule =
    !!schedule?.paymentInformation && schedule.paymentInformation === "PAID"

  if (!src || !link || (isVod && isPaidSchedule)) {
    return null
  }

  return (
    <div className="quickThumb">
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img src={src} alt="이벤트 썸네일" />
      </a>
    </div>
  )
}
